import script from "./TableViewExportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableViewExportModal.vue?vue&type=script&setup=true&lang=ts"

import "./TableViewExportModal.vue?vue&type=style&index=0&id=8decf504&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8decf504"]])

export default __exports__